export const FETCH_CNTRY_CRNCY_INIT_ACTION = "FETCH_CNTRY_CRNCY_INIT_ACTION";
export const FETCH_CNTRY_CRNCY_SUCCESS_ACTION =
  FETCH_CNTRY_CRNCY_INIT_ACTION + "_SUCCESS";
export const FETCH_CNTRY_CRNCY__FAIL_ACTION =
  FETCH_CNTRY_CRNCY_INIT_ACTION + "_ERROR";

export const FETCH_STATES_INIT_ACTION = "FETCH_STATES_INIT_ACTION";
export const FETCH_STATES_SUCCESS_ACTION =
  FETCH_STATES_INIT_ACTION + "_SUCCESS";
export const FETCH_STATES_FAIL_ACTION = FETCH_STATES_INIT_ACTION + "_ERROR";

export const FETCH_DISTRICTBYID_INIT_ACTION = "FETCH_DISTRICTBYID_INIT_ACTION";
export const FETCH_DISTRICTBYID_SUCCESS_ACTION =
  FETCH_DISTRICTBYID_INIT_ACTION + "_SUCCESS";
export const FETCH_DISTRICTBYID_FAIL_ACTION =
  FETCH_DISTRICTBYID_INIT_ACTION + "_ERROR";

export const FETCH_LICENSEE_INIT_ACTION = "FETCH_LICENSEE_INIT_ACTION";
export const FETCH_LICENSEE_SUCCESS_ACTION =
  FETCH_LICENSEE_INIT_ACTION + "_SUCCESS";
export const FETCH_LICENSEE_FAIL_ACTION = FETCH_LICENSEE_INIT_ACTION + "_ERROR";

export const ADD_LICENSEE_INIT_ACTION = "ADD_LICENSEE_INIT_ACTION";
export const ADD_LICENSEE_SUCCESS_ACTION =
  ADD_LICENSEE_INIT_ACTION + "_SUCCESS";
export const ADD_LICENSEE_FAIL_ACTION = ADD_LICENSEE_INIT_ACTION + "_ERROR";

export const EDIT_LICENSEE_INIT_ACTION = "EDIT_LICENSEE_INIT_ACTION";
export const EDIT_LICENSEE_SUCCESS_ACTION =
  EDIT_LICENSEE_INIT_ACTION + "_SUCCESS";
export const EDIT_LICENSEE_FAIL_ACTION = EDIT_LICENSEE_INIT_ACTION + "_ERROR";

export const DELETE_LICENSEE_INIT_ACTION = "DELETE_LICENSEE_INIT_ACTION";
export const DELETE_LICENSEE_SUCCESS_ACTION =
  DELETE_LICENSEE_INIT_ACTION + "_SUCCESS";
export const DELETE_LICENSEE_FAIL_ACTION =
  DELETE_LICENSEE_INIT_ACTION + "_ERROR";

export function fetchLicenseeList() {
  return {
    type: FETCH_LICENSEE_INIT_ACTION
  };
}

export function fetchCntryCrnvy() {
  return {
    type: FETCH_CNTRY_CRNCY_INIT_ACTION
  };
}

export function fetchStates() {
  return {
    type: FETCH_STATES_INIT_ACTION
  };
}

export function fetchDistrictById(value) {
  return {
    type: FETCH_DISTRICTBYID_INIT_ACTION,
    value: value
  };
}

export function AddLicenseeProfile(value) {
  return {
    type: ADD_LICENSEE_INIT_ACTION,
    value: value
  };
}

export function EditLicensee(value) {
  return {
    type: EDIT_LICENSEE_INIT_ACTION,
    value: value
  };
}

export function DeleteLicensee(value) {
  // console.log(value);
  return {
    type: DELETE_LICENSEE_INIT_ACTION,
    value: value
  };
}

export function pageSelected(value) {
  // console.log(value);
  return {
    type: FETCH_LICENSEE_INIT_ACTION,
    value: value
  };
}
